export class SearchFacetFilterProperties {
  constructor(
    public field: string,
    public label: string,
    public isString: boolean
  ) {}
}
